import { FormControl } from "@mui/material";
import { motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import CloseIcon from "../../../../components/CloseIcon/CloseIcon.js";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../../../components/HeaderCadastro/HeaderCadastro.js";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalConfirmacao from "../../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../../components/ModalUsuario/ModalUsuario.tsx";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import SemAutorizacao from "../../../../components/SemAutorizacao/SemAutorizacao.js";
import TabelaV2 from "../../../../components/TabelaV2/TabelaV2.js";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import CoresRedux from "../../../../contexts/Cor.js";
import NomeTabelaRedux from "../../../../contexts/NomeTabela.js";
import RequestControllerRedux from "../../../../contexts/RequestController.js";
import TabelaRedux from "../../../../contexts/Tabela.js";
import DadosUsuarioRedux from "../../../../contexts/Usuario.js";
import {
	cadastraFiliais,
	deleteFiliaisPorId,
	editaFiliaisPorId,
	getFiliais,
	getFiliaisPorId,
} from "../../../../services/ModuloGerenciador/Filiais.js";
import { getRegras } from "../../../../services/ModuloGerenciador/Geral.ts";
import { verificaDadosUsuarioRedux } from "../../../../services/ModuloGerenciador/Usuario.js";
import "./Filiais.css";

function Filiais(props) {
	const { dadosCoresRedux } = useContext(CoresRedux);

	const { dadosUsuarioRedux, setDadosUsuarioRedux } =
		useContext(DadosUsuarioRedux);

	const { dadosRequestControllerRedux, setDadosRequestControllerRedux } =
		useContext(RequestControllerRedux);

	const { dadosTabelaRedux } = useContext(NomeTabelaRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState({});

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const navigate = useNavigate();

	const buscarFiliais = async () => {
		setLoading(true);
		await getFiliais(dadosUsuarioRedux.token)
			.then((result) => {
				setDadosTabela(result.data);
				setTabelaRedux({});
				setTimeout(() => {
					setLoading(false);
				}, 1000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const cadastrar = async () => {
		if (values.nomeFilial !== "" && validator.nomeFilial === "true") {
			setLoading(true);
			await cadastraFiliais(values, dadosUsuarioRedux.token)
				.then((result) => {
					if (result.status === 200) {
						buscarFiliais();
						setDadosRequestControllerRedux("Fechar Modal Filiais");
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
			setLoading(false);
		}
	};

	const editar = async () => {
		setLoading(true);
		await editaFiliaisPorId(values, dadosUsuarioRedux.token)
			.then((result) => {
				if (result.status === 200) {
					buscarFiliais();
					setTabelaRedux({});
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const preencherDadosEditando = async (result) => {
		const valor = opcoes.find((opcao) => opcao.valor === result.sabadoDiaUtil);
		if (valor) {
			setValues((current) => ({ ...current, sabadoDiaUtil: valor.valor }));
			setValuesSelect((current) => ({ ...current, sabadoDiaUtil: valor }));
		}
	};

	const buscarFiliaisPorId = async () => {
		setLoading(true);
		await getFiliaisPorId(
			tabelaRedux.colunaSelecionada,
			dadosUsuarioRedux.token
		)
			.then((result) => {
				if (result.status === 200) {
					if (editando) {
						setValues(result.data);
						preencherDadosEditando(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarFiliaisPorIdModal = async (id) => {
		setLoading(true);
		await getFiliaisPorId(id, dadosUsuarioRedux.token)
			.then(async (result) => {
				if (result.status === 200) {
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarFiliaisPorId = async () => {
		setLoading(true);
		await deleteFiliaisPorId(
			tabelaRedux.colunaSelecionada,
			dadosUsuarioRedux.token
		)
			.then((result) => {
				if (result.status === 200) {
					buscarFiliais();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
		setValues((current) => ({
			...current,
			usuario: dadosUsuarioRedux.usuario.usuario,
		}));
		setValidator((current) => ({ ...current, nomeFilial: "false" }));
	}, [loading]);

	useEffect(() => {
		if (editando) {
			buscarFiliaisPorId();
		}
	}, [editando]);

	useEffect(() => {
		buscarFiliais();
		if (props.idAtual) {
			buscarFiliaisPorIdModal(props.idAtual);
		}
	}, []);

	useEffect(() => {
		if (!!props.telaCadastro) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const [semAutorizacao, setSemAutorizacao] = useState(true);

	useEffect(() => {
		if (dadosUsuarioRedux.regras !== undefined) {
			dadosUsuarioRedux.regras.forEach((element) => {
				if (element === "Filiais") {
					setSemAutorizacao(false);
				}
			});
		} else {
			verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
			getRegras(
				dadosUsuarioRedux.token,
				dadosUsuarioRedux.usuario.idUsuario
			).then((result) => {
				let regras = [];
				result.data.forEach((dado) => {
					regras.push(dado.regras.regra);
					if (dado.regras.regra === "Filiais") {
						setSemAutorizacao(false);
					}
				});
				dadosUsuarioRedux.regras = regras;
				setDadosUsuarioRedux(dadosUsuarioRedux);
			});
		}
	});

	const setSabadoDiaUtil = (event) => {};

	const [valuesSelect, setValuesSelect] = useState([]);

	const labelVeiculo = (data) => <div>{data.opcao}</div>;

	const estiloVeiculo = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			border: "none",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px", // ajuste o tamanho da fonte conforme desejado
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px", // ajuste o tamanho da fonte conforme desejado
		}),
	};

	const opcoesSelect = [
		{
			opcao: "Dia Inteiro",
			valor: true,
		},
		{
			opcao: "Meio Dia",
			valor: false,
		},
		{
			opcao: "Não Conta",
			valor: null,
		},
	];

	const opcoes = opcoesSelect.map((data) => ({
		value: data.opcao,
		label: data.opcao,
		...data,
	}));

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{semAutorizacao ? (
				<>
					{props.navbar ? <></> : <NavbarV3 title="Filiais" selecionado="Filiais" />}
					<SemAutorizacao></SemAutorizacao>
				</>
			) : (
				<div>
					{props.navbar ? <></> : <NavbarV3 title="Filiais" selecionado="Filiais" />}
					{!loading ? (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
						>
							{!telaCadastro ? (
								<div className="embarques">
									<TabelaV2
										setTelaCadastro={setTelaCadastro}
										setEditando={setEditando}
										classeSelecionado="id"
										nomeClasse1="outer-wrapper-cidade"
										nomeClasse2="table-wrapper-cidade-v2"
										colunas={dadosTabelaRedux.Filiais}
										dados={dadosTabela}
									/>
									<div className="container-botoes-cliente">
										<div>
											<CustomButtonV2
												classCss="custom-button-editar"
												classText="button-texto-editar"
												titulo="Editar"
												icone="iconeEdit"
												cor="#CDCDCD"
												valor={values}
												onClick={() => {
													if (tabelaRedux.colunaSelecionada) {
														setTelaCadastro(true);
														setEditando(true);
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
										</div>
									</div>
								</div>
							) : (
								<div>
									{!props.desabilitar ? (
										<div className="indicadores">
											<div className="texto-cadastro">
												<p className="indicador-emb">{"Dados de Filiais / "}</p>
												<p className="indicador-emb">{"Filiais"}</p>
												<HeaderCadastro texto="" />
											</div>
											<div className="close-btn">
												<CloseIcon
													onClick={() => {
														setValues({});
														setValuesSelect({});
														setTelaCadastro(false);
														setEditando(false);
														setTabelaRedux({});
													}}
												/>
											</div>
										</div>
									) : (
										<></>
									)}
									<div className="flex-column">
										<div className="container-select-emb">
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div className="principal-filiais">
														<p className="input-label-emb" htmlFor="descricao">
															Nome Filial:
														</p>
														<input
															type="text"
															className="input-emb"
															style={{ width: "270px" }}
															onChange={(e) => {
																setValues((current) => ({
																	...current,
																	nomeFilial: e.target.value,
																}));
																setValidator((current) => ({
																	...current,
																	nomeFilial: "true",
																}));
															}}
															placeholder="Ex: Pallet"
															value={values.nomeFilial}
															disabled={props.desabilitar}
														/>
														<p className="input-label-emb" htmlFor="descricao">
															Sábado Dia Útil:
														</p>
														<FormControl sx={{ width: 265 }}>
															<Select
																value={valuesSelect.sabadoDiaUtil}
																options={opcoes}
																formatOptionLabel={labelVeiculo}
																styles={estiloVeiculo}
																placeholder="Selecione"
																noOptionsMessage={() => "Não há mais opções"}
																onChange={(selectedOption) => {
																	if (selectedOption) {
																		setValues((current) => ({
																			...current,
																			sabadoDiaUtil: selectedOption.valor,
																		}));
																		setValuesSelect((current) => ({
																			...current,
																			sabadoDiaUtil: selectedOption,
																		}));
																		setValidator((current) => ({
																			...current,
																			sabadoDiaUtil: "true",
																		}));
																	}
																}}
															/>
														</FormControl>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="botoes-filiais">
										{editando ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Editar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													editar();
													setTelaCadastro(false);
													setEditando(false);
													setValues({});
													setValuesSelect({});
												}}
											/>
										) : (
											<>
												{!props.desabilitar ? (
													props.botaoCadastrar ? (
														<CustomButtonV2
															classCss="custom-button-cadastrar"
															classText="button-texto-cadastrar"
															icone="iconeSave"
															titulo="Editar"
															cor="#0946B8"
															valor={values}
															onClick={() => {
																if (
																	values.nomeFilial !== "" &&
																	validator.nomeFilial === "true"
																) {
																	cadastrar();
																	setValues({});
																	setValuesSelect({});
																} else {
																	setTextoErro("Há campos sem preencher!");
																	setOpenToastErro(true);
																}
															}}
														/>
													) : (
														<CustomButtonV2
															classCss="custom-button-cadastrar"
															classText="button-texto-cadastrar"
															icone="iconeSave"
															titulo="Editar"
															cor="#0946B8"
															valor={values}
															onClick={() => {
																if (
																	values.nomeFilial !== "" &&
																	validator.nomeFilial === "true"
																) {
																	cadastrar();
																	setValues({});
																	setValuesSelect({});
																	setTelaCadastro(false);
																} else {
																	setTextoErro("Há campos sem preencher!");
																	setOpenToastErro(true);
																}
															}}
														/>
													)
												) : (
													<></>
												)}
											</>
										)}
										{props.botaoVoltar ? (
											<></>
										) : (
											<CustomButtonV2
												classCss="custom-button-cancelar"
												classText="button-texto-cancelar"
												titulo="Cancelar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													setValues({});
													setTelaCadastro(false);
													setEditando(false);
													setTabelaRedux({});
													setValuesSelect({});
												}}
											/>
										)}
									</div>
								</div>
							)}
							<div>
								<ModalConfirmacao
									titulo="Deletar"
									texto="Deseja Deletar?"
									tituloConfirmar="Confirmar"
									tituloCancelar="Cancelar"
									open={open}
									onClose={handleClose}
									onClick={deletarFiliaisPorId}
								/>
								<ModalUsuario
									titulo="Usuário"
									tituloConfirmar="OK"
									open={openUsuario}
									onClose={handleCloseUsuario}
								/>
							</div>
							<div>
								<ToastSucesso
									texto={textoSucesso}
									open={openToastSucesso}
									onClose={handleCloseToastSucesso}
								/>
								<ToastErro
									texto={textoErro}
									open={openToastErro}
									onClose={handleCloseToastErro}
								/>
							</div>
						</motion.div>
					) : (
						<LoadingComponent />
					)}
				</div>
			)}
		</motion.div>
	);
}

export default Filiais;
